import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PromotionItem } from '../offer-card-data.model';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { ModuleService } from 'projects/common/services/module.service';

@Component({
  selector: 'dual-promo',
  template: `
    <div [ngClass]="{'-compound' : promotionsList.length > 1,
      '-green' : promotionsList.length === 1 && (promotionsList[0].promo_type === 'COMMON' || promotionsList[0].promo_type === 'COUPON'),
      '-purple' : promotionsList.length === 1 && promotionsList[0].promo_type === 'CROSS_SELLING',
      '-secret-deals' : promotionsList.length === 1 && promotionsList[0].promo_type === 'LOGGED_IN',
      '-hotsale' : promotionsList.length === 1 && promotionsList[0].promo_type === 'HOTSALE',
      '-ifood' : promotionsList.length === 1 && promotionsList[0].promo_type === 'IFOOD'}"
      class="offer-card-pricebox-label eva-3-label -sm {{position}}" >

      <span *ngFor="let promo of promotionsList" class="label-container "
        [ngClass]="{' -eva-3-bc-bubblegum-1' : promo?.promo_type === 'LOYALTY', '-eva-3-bc-white' : promo.promo_type === 'LOGGED_IN'}">
        <tooltip backgroundColor="-white" position='-top -left' product="nymeria-gui" flow="landing" [openOnHover]="(promo?.promo_type === 'LOYALTY' || promo?.promo_type === 'LOGGED_IN') && promo.ribbon.length <= 3">
          <i label *ngIf="promo.promo_type === 'LOYALTY'" class="eva-3-icon-loyalty-filled label-icon"></i>
          <i label *ngIf="promo.promo_type === 'CROSS_SELLING'" class="label-icon eva-3-icon-pig-offer-filled -eva-3-mr-xsm" ></i>
          <i label *ngIf="promo.promo_type === 'COUPON'" class="label-icon eva-3-icon-{{isStressContent ? 'pm-pad' : 'ticket'}} -eva-3-mr-xsm" ></i>
          <i label *ngIf="promo.promo_type === 'LOGGED_IN'" class="eva-3-icon-gift label-icon -eva-3-tc-red-3"></i>
          <span label class="-eva-3-bold label-text " [ngClass]="{'-linethrough' : promo.is_crossed_out, '-eva-3-tc-gray-1' : promo.promo_type === 'LOGGED_IN'}">{{promo.ribbon.length === 1 ? "- %" : promo.ribbon}}</span>

          <div tooltip-title class="eva-3-h5">{{promo.promo_type === 'LOYALTY' ? ("offers.loyalty.tooltipDiscount.title" | translate) : "offers.gift.tooltipDiscount.title" | translate }}</div>
          <span tooltip-content class="tooltip-text">
            {{promo.promo_type === 'LOYALTY' ? ("offers.loyalty.tooltipDiscount.content" | translate) : "offers.gift.tooltipDiscount.content" | translate}}
          </span>
        </tooltip>
      </span>
    </div>
  `,
  styleUrls: ['./dual-promo.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DualPromoComponent {
  @Input() promotionsList: PromotionItem[];
  @Input() position: '-top-left' | '-top-right' | '-bottom-left' | '-bottom-right' = '-top-right';

  isStressContent: boolean;

  constructor(private landingModelService: LandingModelService) {
    this.isStressContent = landingModelService.getLandingModel().abTests?.ab.includes("S-PIG-RETURNERS|branch_test");
  }
}
